
define('modules/application/wizard/classes/outerRadioProbe',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericIncrementalElement"

],

function(app, Backbone, genericIncrementalElement) {

  var outerradioprobe   = _.extend({}, genericIncrementalElement, {

    Views : {
      titleBar  : genericIncrementalElement.Views.titleBar.extend({
        events : {
          "click" : "titleBarClickedEventHandler"
        },
        initialize                    : function() {
          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);
          genericIncrementalElement.Views.titleBar.prototype.initialize.apply(this);
        },

        titleBarClickedEventHandler   : function(e) {
          this.model.trigger("tooltips:toggle");
        },

        setLabel                      : function() {
          if ((this.model.get("value")!==null)&&(this.model.get("interfaceValue")>0))
          {
            this.$el.find(".titleBarcontent span").html(this.model.get("value") + " " + $.i18n._("IDS_WTR1_209") + " - " + this.model.get("interfaceValue") + " " + $.i18n._("IDS_WTR2_238"));
            this.$el.find(".titleBarcontent span").fadeIn(200);
          }
          else
            this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        afterRender  :  function() {
          this.$el.children(".titleBarcontent").prepend($.i18n._("IDS_WTR1_209"));

          //if (!this.model.get("enabled"))
          //  this.$el.children(".titleBarcontent").append(' - ' + $.i18n._("IDS_W1_9102"));
        }
      }),
      content   : genericIncrementalElement.Views.content.extend({
        template  : "application/wizard/sections/outerRadioProbes/content",
        events    : _.extend({
          "click .interfaceValue .ui-spinner-up"    : "incrementInterfaceValue",
          "click .interfaceValue .ui-spinner-down"  : "decrementInterfaceValue",
          "click .toggleProbesInfoButton"           : "toggleProbesInfos",
          "click .toggleInterfacesInfoButton"       : "toggleInterfacesInfos"
        }, genericIncrementalElement.Views.content.prototype.events),

        initialize                             : function() {
          genericIncrementalElement.Views.content.prototype.initialize.apply(this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("tooltips:toggle", this.tooltipToggleRequestedEventHandler);
          this.model.bind("tooltips:toggle", this.tooltipToggleRequestedEventHandler, this);
        },

        toggleProbesInfos : function(e) {
          e.preventDefault();
          this.toggleInfos("probes");
          return false;
        },

        toggleInterfacesInfos : function(e) {
          e.preventDefault();
          this.toggleInfos("interfaces");
          return false;
        },

        toggleInfos                            : function(sectionToClose) {
          var that       = this,
              tagClass   = "."+sectionToClose+"Tooltip",
              buttonClass= ".toggle" + sectionToClose.charAt(0).toUpperCase()+sectionToClose.slice(1) + "InfoButton";

          if (window.isBrowserCompatibleWithAnimation())
          {
            that.$el.find(buttonClass + " .arrow-info").transition({ rotate: "+=180" });
          }
          else
          {
            if (this.$el.find(buttonClass + " .tooltip:visible").length>0)
              that.$el.find(buttonClass + " .arrow-info").attr("src", "/assets/img/info-arrow-down.png");
            else
              that.$el.find(buttonClass + " .arrow-info").attr("src", "/assets/img/info-arrow-up.png");
          }

          if (this.$el.find(tagClass+":visible").length===0)
            that.$el.find(tagClass + " hr").toggle();

          this.$el.find(tagClass).slideToggle(function() {if (that.$el.find(tagClass+":visible").length===0) that.$el.find(tagClass + " hr").toggle();});
        },

        decrementInterfaceValue                : function() {
          if (this.model.get("enabled"))
            this.model.decrementInterfaceValue();
        },

        incrementInterfaceValue                : function() {
          if (this.model.get("enabled"))
            this.model.incrementInterfaceValue();
        },

        disableSection                 : function() {
          if (!this.model.get("enabled"))
          {
            this.$el.find(".mainValue").addClass("disabled");
            this.$el.find(".interfaceValue").addClass("disabled");
          }
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
          {
            this.$el.find(".mainValue").removeClass("disabled");
            this.$el.find(".interfaceValue").removeClass("disabled");
          }
        },

        updateSpinners                        : function() {
          this.$el.find(".mainValue .spinner").html(this.model.get("value"));
          this.$el.find(".interfaceValue .spinner").html(this.model.get("interfaceValue"));
        },

        afterRender                           : function() {
          var urlLink;
          this.$el.find("h4.mainTitle").html($.i18n._(this.model.get("wizardChoiceLabel")));

          if ((this.model.get("wizardChoiceLabel"))&&(this.model.get("wizardChoiceLabel")!==""))
            this.$el.find(".title.mainElement").html($.i18n._("IDS_WTR1_209_SUB"));
        }

      })
    },

    Model       : genericIncrementalElement.Model.extend({

      defaults                 :  _.extend({}, genericIncrementalElement.Model.prototype.defaults, {
        interfaceValue  : 0,
        maxValue        : 9
      }),

      initialize               :  function()                {

        this.unbind("change:value",   this.mainValueUpdated);
        this.bind("change:value",     this.mainValueUpdated, this);

        this.unbind("change:enabled", this.enabledChangedEventHandler);
        this.bind("change:enabled",   this.enabledChangedEventHandler, this);

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen',  this.getInterface);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen',    this.getInterface, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",this.deliverCurrent, this);

        genericIncrementalElement.Model.prototype.initialize.apply(this);
      },

      enabledChangedEventHandler : function()               {
        this.set("value", 0);
        this.trigger("render:requested");
      },

      deliverModel             : function()                 {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.outerRadioProbe = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.outerRadioProbe = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.outerRadioProbe = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.outerRadioProbe = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.outerRadioProbe = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.outerRadioProbe = this;
              break;
          }
        BticinoS4B.Instances.Models.ApplicationModel.set("outerRadioProbe", this);
        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i            = 0;

        if (this.get("enabled"))
        {
          dataProvider.addItems("externalItems", {
            productCode       : this.get("productCode"),
            productLabel      : this.get("productLabel"),
            packageClassLabel : this.get("packageClassLabel"),
            kitValue          : this.get("kitValue"),
            partOfKit         : this.get("partOfKit"),
            quantity          : this.get("value"),
            price             : this.get("price")
          });

          if (this.get("secondaryProducts"))
          {
            for (i=0; i<this.get("secondaryProducts").length; i++)
            {
              dataProvider.addItems("externalItems", {
                productCode       : this.get("secondaryProducts")[i].productCode,
                productLabel      : this.get("secondaryProducts")[i].productLabel,
                packageClassLabel : this.get("secondaryProducts")[i].packageClassLabel,
                kitValue          : this.get("kitValue"),
                partOfKit         : this.get("partOfKit"),
                quantity          : this.get("value"),
                price             : this.get("secondaryProducts")[i].price
              });
            }
          }

          if (this.get("interfaceAttributes"))
          {
            dataProvider.addItems("externalItems", {
              productCode       : this.get("interfaceAttributes").productCode,
              productLabel      : this.get("interfaceAttributes").productLabel,
              packageClassLabel : this.get("interfaceAttributes").packageClassLabel,
              kitValue          : this.get("interfaceAttributes").kitValue,
              partOfKit         : this.get("interfaceAttributes").partOfKit,
              quantity          : this.get("interfaceValue"),
              price             : this.get("interfaceAttributes").price
            });

            if (this.get("secondaryProducts"))
            {
              for (i=0; i<this.get("interfaceAttributes").secondaryProducts.length; i++)
              {
                dataProvider.addItems("externalItems", {
                  productCode       : this.get("interfaceAttributes").secondaryProducts[i].productCode,
                  productLabel      : this.get("interfaceAttributes").secondaryProducts[i].productLabel,
                  packageClassLabel : this.get("interfaceAttributes").secondaryProducts[i].packageClassLabel,
                  kitValue          : this.get("kitValue"),
                  partOfKit         : this.get("partOfKit"),
                  quantity          : this.get("interfaceValue"),
                  price             : this.secondaryProducts[i].price
                });
              }
            }
          }
        }
      },

      mainValueUpdated         :  function()                {
        var numberOfOuterRadioProbes = this.get("value");
        var numberOfInterfaces       = this.get("interfaceValue");

        if (numberOfInterfaces<Math.ceil(numberOfOuterRadioProbes/2)) {
          this.set("interfaceValue", Math.ceil(numberOfOuterRadioProbes/2));
          this.trigger("updateViews");
        }
        else if (numberOfInterfaces>numberOfOuterRadioProbes) {
          this.set("interfaceValue", numberOfOuterRadioProbes);
          this.trigger("updateViews");
        }
      },

      incrementInterfaceValue  :  function()                {
        if (this.get("enabled"))
        {
          if ((this.get("interfaceValue")+1)<=this.get("value"))
          {
            this.set("interfaceValue", (this.get("interfaceValue")+1));
            this.trigger("updateViews");
          }
          return this.get("interfaceValue");
        }
        else
          return null;
      },

      decrementInterfaceValue  :  function()                {
        if (this.get("enabled"))
        {
          if ((this.get("interfaceValue")>0)&&((this.get("interfaceValue")-1)>=Math.ceil(this.get("value")/2)))
          {
            this.set("interfaceValue", (this.get("interfaceValue")-1));
            this.trigger("updateViews");
          }
          return this.get("interfaceValue");
        }
        else
          return null;
      },

      getPackages              :  function(accessoryLineId) {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("209", function(data) {
          for (var i = data.packages.length - 1; i >= 0; i--) {
            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
          }
          //Sorting elements by packageClassId
          that.fetchedProbes = data.packages;

          that.fetchedProbes.sort(function (a, b) {
              if (parseInt(a.packageClassId, 10) < parseInt(b.packageClassId, 10))
                return -1;

              if (parseInt(a.packageClassId, 10) > parseInt(b.packageClassId, 10))
                return 1;

              return 0;
            }
          );


          var currentpackageClassid = "-1";
          for (i = 0; i<that.fetchedProbes.length; i++)
          {
            if (currentpackageClassid!==that.fetchedProbes[i].packageClassId)
              currentpackageClassid = that.fetchedProbes[i].packageClassId;
            else
            {
              that.fetchedProbes.splice(i,1);
              i--;
            }
          }

          _.extend(that.attributes, that.fetchedProbes[0]);

          //Retrieving product details
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(that.get("packageClassId"), function(data) {
            data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);});
            var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            if (mainProduct.length>0)
              mainProduct=mainProduct[0];

            _.extend(that.attributes, mainProduct);
            that.set("secondaryProducts", secondaryProducts);
          });
        });
      },

      getInterface             :  function(accessoryLineId) {
        this.getPackages();
        var that = this;

        var successCallback = function(data) {
          if (data.packages.length === 0) {
            //break;
          }
          else
          {
            for (var i = data.packages.length - 1; i >= 0; i--)
            {
              data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);
            }
            that.set("enabled", true);
            var pack = data.packages[0];
            that.set("interfaceAttributes", pack);
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(pack.packageClassId, function(data) {
              data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
              var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

              mainProduct.secondaryProducts = secondaryProducts;
              _.extend(that.attributes.interfaceAttributes, mainProduct);
              that.trigger("render:requested");
            });
          }
        };

        var errorCallback = function() {
          that.set("enabled", false);
        };

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("215", successCallback, errorCallback);
      },

      loadProject              : function(model)            {
        if(model.outerRadioProbe){
          if (!model.outerRadioProbe.quantity)
            model.outerRadioProbe.quantity = 0;

          this.set("value", model.outerRadioProbe.quantity);

          if (!model.outerRadioProbe.interfaceQuantity)
            model.outerRadioProbe.interfaceQuantity = 0;

          this.set("interfaceValue", model.outerRadioProbe.interfaceQuantity);
          this.trigger("updateViews");
        }
      },

      deliverCurrent            : function() {
        if (this.get("enabled"))
        {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          if (this.get("specialVars") && consumptionIndicatorModel) {
            var currentConsumption        = this.get("specialVars").currentConsumption*this.get("value")+
                                            this.get("interfaceAttributes").specialVars.currentConsumption*this.get("interfaceValue");

            if (currentConsumption<0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }
        }
      }

    })
  });

  // Required, return the module for AMD compliance
  return outerradioprobe;

});